import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Alert,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function HomeCategory() {
  var history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [imageKey, setImageKey] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [imageData, setImageData] = useState(null);
  const [image, setImage] = useState(null);
  const [categoryTitle, setCategoryTitle] = useState("");
  const [purpose, setPurpose] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [city, setCity] = useState("");
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [catId, setCatId] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [show1, setShow1] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  function getData() {
    axios
      .get(`${Baseurl.baseurl4}/go-food-admin/get-food-home-category`)
      .then((res) => {
        console.log("categoiryeueye", res.data.homeCategory);
        setSpinner(false);
        setAllCategory(res.data.homeCategory);
        setSearchData(res.data.homeCategory);
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val.Category.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setAllCategory(filteredData);
  }
  const onChangePicture = (e) => {
    if (e.target.files[0].size / 1048576 < 3) {
      setImage(e.target.files[0]);
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImageData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };
  function addCategory() {
    const data = new FormData();
    let valStartTime = startTime.split(":");
    let valEndTime = endTime.split(":");
    data.append("image", image);
    data.append("title", categoryTitle);
    data.append("city", city);
    data.append("category", categoryName);
    data.append("purpose", purpose);
    data.append("sHour", valStartTime[0]);
    data.append("sMinute", valStartTime[1]);
    data.append("eHour", valEndTime[0]);
    data.append("eMinute", valEndTime[1]);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl4}/go-food-admin/create-food-home-category`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setCategoryTitle("");
          setImage(null);
          setImageData(null);

          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function updateCategory() {
    let valStartTime = startTime.split(":");
    let valEndTime = endTime.split(":");
    let catFields = {
      title: categoryTitle,
      city: city,
      category: categoryName,
      purpose: purpose,
      sHour: valStartTime[0],
      sMinute: valStartTime[1],
      eHour: valEndTime[0],
      eMinute: valEndTime[1],
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-admin/update-food-home-category/${catId}`,
        catFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function updateCategoryImage() {
    const data = new FormData();
    data.append("imageKey", imageKey);
    data.append("image", image);
    var config = {
      method: "put",
      url: `${Baseurl.baseurl4}/go-food-admin/update-food-home-category-image/${catId}`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setCategoryTitle("");
          setImage(null);
          setImageData(null);

          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function deleteCategory() {
    axios
      .delete(
        `${Baseurl.baseurl4}/go-food-admin/delete-food-home-category/${catId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }

  function updateFunction(val) {
   
    setCatId(val._id);
    setUpdateStatus(true);
    setCategoryTitle(val.Title);
    setCategoryName(val.Category);
    setCity(val.City);
    setPurpose(val.Purpose);

    setImageData(val.FoodImage);
    setImageKey(val.FoodImageKey);
    setStartTime(`${val.StartTime.Hour}:${val.StartTime.Minute}`);
    setEndTime(`${val.EndTime.Hour}:${val.EndTime.Minute}`);
    // if (String(Math.abs(val.StartTime.Hour)).length === 1) {
    //   setStartTime(`0${val.StartTime.Hour}:${val.StartTime.Minute}`);
    // } else {
    //   setStartTime(`${val.StartTime.Hour}:${val.StartTime.Minute}`);
    // }
    // if (String(Math.abs(val.EndTime.Hour)).length === 1) {
    //   setEndTime(`0${val.EndTime.Hour}:${val.EndTime.Minute}`);
     
    // } else {x
    //   setEndTime(`${val.EndTime.Hour}:${val.EndTime.Minute}`);
    // }
    setShow(true);
  }
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Test</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h4>Are You Sure You Want to Delete This Category ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteCategory();
            }}
            className="btn btn-primary"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
              <div className="col-sm-2 mt-2">
                <label>
                  Category Name <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={categoryName}
                  type="text"
                  className="form-control"
                  placeholder="enter Category Name"
                  onChange={(e) => setCategoryName(e.target.value)}
                  required
                />
              </div>

              <div className="col-sm-2 mt-2">
                <label>
                  City <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={city}
                  type="text"
                  className="form-control"
                  placeholder="enter city Name"
                  onChange={(e) => setCity(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-2 mt-3">
                <label>Start Time</label>
                <span className="text-danger">*</span>
              </div>
              <div className="col-sm-4">
                <input
                  type="time"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={startTime}
                  onChange={(e) => {
                    setStartTime(e.target.value);
                  }}
                  required
                />
              </div>

              <div className="col-sm-2 mt-3">
                <label>End Time</label>
                <span className="text-danger">*</span>
              </div>
              <div className="col-sm-4">
                <input
                  type="time"
                  className="form-control"
                  id="val-username"
                  name="val-username"
                  value={endTime}
                  onChange={(e) => {
                    setEndTime(e.target.value);
                  }}
                  required
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-2 mt-2">
                <label>
                  Category Title <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={categoryTitle}
                  type="text"
                  className="form-control"
                  placeholder="enter Category Title"
                  onChange={(e) => setCategoryTitle(e.target.value)}
                  required
                />
              </div>

              <div className="col-sm-2 mt-2">
                <label>
                  Purpose <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={purpose}
                  type="text"
                  className="form-control"
                  placeholder="enter purpose"
                  onChange={(e) => setPurpose(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-1 mr-4">
                <label htmlFor="val-range">
                  Category Image
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div classname="col-sm-4">
                <div className="register_profile_image mt-2">
                  <input
                    id="profilePic"
                    type="file"
                    onChange={(e) => {
                      onChangePicture(e);
                    }}
                  />
                </div>
                {imageData && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="previewProfilePic"
                  >
                    <img
                      alt=""
                      className="playerProfilePic_home_tile"
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={imageData}
                    />
                  </div>
                )}
                {updateStatus && (
                  <div className="col-sm-2 ">
                    <button
                      onClick={() => {
                        updateCategoryImage();
                      }}
                      className="btn btn-primary mt-3"
                    >
                      Change
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateCategory();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addCategory();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              setShow(true);
              setUpdateStatus(false);
              setCategoryTitle("");
              setImageData(null);
              setCity('')
              setCategoryName('')
              setPurpose('')
            }}
            className="btn btn-primary"
          >
            Add Category
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong>Image</strong>
                    </th>

                    <th>
                      <strong> Name</strong>
                    </th>
                    {/* <th>
                      <strong>Title</strong>
                    </th> */}
                    <th>
                      <strong>City</strong>
                    </th>
                    {/* <th>
                      <strong>Purpose</strong>
                    </th> */}
                    <th>
                      <strong>Start Time</strong>
                    </th>
                    <th>
                      <strong>End Time</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allCategory &&
                    allCategory.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>
                        <td>
                          <img
                            src={val.FoodImage}
                            height={40}
                            width={40}
                            alt="profile"
                          />
                        </td>
                        <td>{val.Category}</td>
                        {/* <td>{val.Title}</td> */}
                        <td>{val.City}</td>
                        <td>
                          {val.StartTime.Hour}:{val.StartTime.Minute}
                        </td>
                        <td>
                          {val.EndTime.Hour}:{val.EndTime.Minute}
                        </td>
                        {/* <td>{val.Purpose}</td> */}
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>

                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allCategory && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allCategory
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default HomeCategory;
